import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AudioService {
  private audio: HTMLAudioElement;
  private permissionGranted = false;
  private permissionAsked = false;

  constructor() {
    this.audio = new Audio('assets/sounds/notification.mp3');
    this.audio.load();
    console.log('Service Audio initialisé');

    // Vérifier si l'utilisateur a déjà donné son autorisation
    const savedPermission = localStorage.getItem('notificationSoundPermission');
    if (savedPermission === 'granted') {
      this.permissionGranted = true;
    }
  }

  async requestPermission(): Promise<boolean> {
    if (this.permissionGranted || this.permissionAsked) {
      return this.permissionGranted;
    }

    this.permissionAsked = true;

    try {
      // Jouer un son très court pour obtenir l'autorisation
      this.audio.volume = 0.1;
      await this.audio.play();
      this.audio.pause();
      this.audio.currentTime = 0;
      this.audio.volume = 1;
      
      this.permissionGranted = true;
      localStorage.setItem('notificationSoundPermission', 'granted');
      return true;
    } catch (error) {
      console.error('Permission refusée pour le son:', error);
      return false;
    }
  }

  async playMessageNotification() {
    if (!this.permissionGranted) {
      const granted = await this.requestPermission();
      if (!granted) {
        console.log('Permission non accordée pour jouer le son');
        return;
      }
    }

    console.log('Tentative de lecture du son...');
    this.audio.currentTime = 0;
    
    try {
      await this.audio.play();
      console.log('Son joué avec succès');
    } catch (error) {
      console.error('Erreur lors de la lecture du son:', error);
      this.audio.load();
    }
  }
}
